export default __webpack_public_path__ + "b5b372d9393ee0f4b1e3bdfa3df9868e.jpg";